import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { CiMail } from "react-icons/ci";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const Year = new Date().getFullYear();
  const { t } = useTranslation('footer');
  
  return (
    <footer className="w-full bg-gray-900 text-white relative left-0 right-0">
      <div className="w-full flex flex-col tablet:ml-0">
        <div className="w-full max-w-7xl mx-auto px-4 tablet:px-8 flex flex-col gap-3">
          <div className="flex flex-col tablet:flex-row justify-between border-b-[1px] py-6 border-gray-700 gap-4 tablet:gap-0">
            {/* Logo & Contact */}
            <div className="flex flex-col gap-3 w-full tablet:w-1/3">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm">{t('privacy')}</Link>
              <Link to="/terms-conditions" className="text-gray-400 hover:text-white text-sm">{t('terms')}</Link>
            </div>
            
            <div className="w-fit tablet:w-2/3 flex flex-row gap-20 items-start justify-end">
              {/* Navigation Links */}
              <div className="flex flex-col">
                <h3 className="font-semibold text-lg mb-2">{t('quickLinks')}</h3>
                <ul className="flex flex-col gap-1">
                  <li><Link to="/about" className="text-gray-300 hover:text-white text-base">{t('aboutUs')}</Link></li>
                  <li><Link to="/vetting" className="text-gray-300 hover:text-white text-base">{t('resources')}</Link></li>
                  <li><Link to="/contact" className="text-gray-300 hover:text-white text-base">{t('contact')}</Link></li>
                </ul>
              </div>
              
              {/* Social Links */}
              <div className="flex flex-col">
                <h3 className="font-semibold text-lg mb-2">{t('followUs')}</h3>
                <div className="flex gap-4 mb-2">
                  <a href="https://www.facebook.com/unido.kenya.ac" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white"><FaFacebook className="w-6 h-6" /></a>
                  <a href="https://x.com/unido_kenya" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white"><FaTwitter className="w-6 h-6" /></a>
                  <a href="https://www.linkedin.com/company/unido-kenya" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white"><FaLinkedin className="w-6 h-6" /></a>
                  <a href="https://www.instagram.com/unido_org" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white"><FaInstagram className="w-6 h-6" /></a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="w-full flex flex-col tablet:flex-row justify-between items-center py-4">
            <span className="text-gray-400 text-sm mb-2 tablet:mb-0">{t('copyright')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
